// BuilderPlaceHint - 「ここには置けない」を、子どもがタップした場所に出す吹き出し。
// 画面いちばん上のトーストは、マップを見ている子どもの目に入らないので使わない。

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";
import I18n from "common/i18n";
import { useScale } from "common/utils";
import { actions } from "features/builder/slice";

const WIDTH = 380;
/** 吹き出しと、指を置いた場所とのすき間 */
const GAP = 16;
/** 出しっぱなしにせず、読めるだけ出して消す */
const SHOW_MS = 1800;

export const BuilderPlaceHint = () => {
  const dispatch = useDispatch();
  const { scale } = useScale();
  const hint = useSelector((state: RootState) => state.builder.placeHint);

  useEffect(() => {
    if (!hint) return;
    const timer = setTimeout(() => dispatch(actions.clearPlaceHint()), SHOW_MS);
    return () => clearTimeout(timer);
  }, [hint, dispatch]);

  if (!hint) return null;

  // 画面のはしをタップしても吹き出しが切れないように内側に寄せる
  const half = (WIDTH * scale) / 2;
  const left = Math.min(Math.max(hint.x, half + GAP), window.innerWidth - half - GAP);
  const top = Math.max(hint.y - GAP, half);

  return (
    <div className="flex-col-el fixed z-[10000] pointer-events-none" style={{ left, top }}>
      <div
        className="flex-col-el relative"
        style={{
          width: WIDTH,
          transform: `translate(-50%, -100%) scale(${scale})`,
          transformOrigin: "bottom center",
        }}
      >
        <div className="flex-row-el items-center gap-2 w-full px-3 py-2 bg-white rounded-full shadow-lg box-border">
          <span className="flex-col-el flex-center material-symbols-outlined type-md text-danger">
            info
          </span>
          <p className="type-text-left type-sm text-textcolor-black flex-1 whitespace-nowrap">
            {I18n.t(hint.messageKey)}
          </p>
        </div>
        {/* しっぽ。吹き出しと同じ白を回転させて、下辺から半分だけ出す */}
        <div className="flex-col-el absolute left-1/2 -ml-2 -bottom-2 w-4 h-4 bg-white rotate-45" />
      </div>
    </div>
  );
};
